import axios from 'axios';
import AgreementLimit from '../entity/agreement-limit.entity';

export default class AgreementLimitService {
  public static findAll(): Promise<any> {
    return axios.get('/api/agreement-limits');
  }

  public static updateAll(limits: AgreementLimit[]): Promise<any> {
    return axios.put('/api/agreement-limits', limits.map(limit => limit.toPayload()));
  }

  public static getHistory(page: number, size: number): Promise<any> {
    return axios.get('/api/agreement-limits/history', { params: { page, size } });
  }
}
